let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cridM")).then(() => parcelRequire('flVrS'));